import { PrismaWorkspaceDto } from 'app/API';

export const sortWorkspacesByName = (workspaces: PrismaWorkspaceDto[]): PrismaWorkspaceDto[] =>
  [...workspaces].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
